const GET_REJECTION_REASON = "GET_REJECTION_REASON"
const GET_REJECTION_REASON_SUCCESS = "GET_REJECTION_REASON_SUCCESS"
const GET_REJECTION_REASON_FAIL = "GET_REJECTION_REASON_FAIL"

const BASE_ENDPOINT = '/InvoiceManagement/';
const initialValues = {
    loading: false,
    hasError: false,
    data: null
};

const accountRejectionReason = (state = initialValues, action) => {

    switch (action.type) {

        case GET_REJECTION_REASON: {
            return {
                ...state,
                loading: true,
            }
        }

        case GET_REJECTION_REASON_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false,
            }
        }

        case GET_REJECTION_REASON_FAIL: {
            return {
                ...state,
                loading: false,
                hasError: true,
            };
        }

        default: {
            return state;
        }

    }
};

export const getRejectionReason = (guidOperation) => {

    return {
        type: GET_REJECTION_REASON,
        payload: {
            request: {
                method: "GET",
                url: BASE_ENDPOINT + `ReasonRejection?guid=${guidOperation}`
            },
        },
    };
};

export default accountRejectionReason;